import { render } from "./SchemaHeading.vue?vue&type=template&id=5123e7e6"
import script from "./SchemaHeading.vue?vue&type=script&lang=js"
export * from "./SchemaHeading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__